import { ShippingMethod, shippingMethodFromResponse } from './ShippingMethod';
import {
  BankTransferInstructions,
  bankTransferInstructionsFromResponse,
} from '../Checkout/BankTransferInstructions';

export interface ShippingMethodsAndBankTransferInstructions {
  shippingMethods: ShippingMethod[];
  bankTransferInstructions: BankTransferInstructions;
}

export const shippingMethodsAndBankTransferInstructionsFromResponse = (
  responseData: any,
): ShippingMethodsAndBankTransferInstructions => ({
  shippingMethods: responseData.shippingMethods.map(shippingMethodFromResponse),
  bankTransferInstructions: bankTransferInstructionsFromResponse(
    responseData.paymentMethods.bank_transfer.instruction_fields,
    responseData.paymentMethods.bank_transfer.enabled,
  ),
});
